import api from 'api'

export const updateProject = async (id, payload) => {
  const { data } = await api.put(`/project/${id}`, payload)

  return data
}